import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughAutoReplyProps = {
  node: ConversationFlowAuditLogEntry<'AUTO_REPLY_NODE_VISITED'>;
};

export function RoutedThroughAutoReply({
  node,
}: RoutedThroughAutoReplyProps): JSX.Element {
  return (
    <>
      Auto-reply · Template <strong>{node.template_id}</strong> sent
    </>
  );
}
